import React, { PureComponent } from 'react';
import { range } from 'lodash';

import { AxisLabels } from 'frontend-component-library';

class DNAGraph extends PureComponent {
  getAxisInfo = () => {
    const { recommendationsCount } = this.props;
    const increment = 4;
    const max = recommendationsCount;
    const step = max / increment;
    return { step, max };
  };

  getLabels = () => {
    const { step, max } = this.getAxisInfo();
    return range(0, max + step, step).map((val, i) => {
      let roundedVal = Math.round(val);
      if (val === 0) {
        roundedVal = 1;
      }
      return { value: roundedVal, text: roundedVal, index: i };
    });
  };

  render() {
    const { step, max } = this.getAxisInfo();
    return (
      <AxisLabels min={0} max={max} step={step} labels={this.getLabels()} />
    );
  }
}

export default DNAGraph;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/DNAGraph/DNAGraphLabels.js